import { z } from 'zod';
export const CategoryColourSchema = z
    .string()
    .trim()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .transform((v) => v.toLowerCase());
/** Just an optional grouping now: id, name, sort order, colour. Stock codes live on products. */
export const CategorySchema = z.object({
    id: z.number().int(),
    name: z.string(),
    sortOrder: z.number().int(),
    colour: z.string().nullable(),
    createdAt: z.string(),
    productCount: z.number().int().optional(),
});
export const CreateCategoryRequestSchema = z.object({
    name: z.string().trim().min(1).max(40),
    // No `.default(0)`: a client that omits sortOrder should land after every
    // existing category (max existing + 1), not collide at 0 with whichever
    // category got there first - the route computes that when this is
    // `undefined`. See the QA reverify report's new-finding "POST
    // /api/categories still defaults sortOrder to 0".
    sortOrder: z.number().int().optional(),
    colour: CategoryColourSchema.nullable().optional(),
});
export const UpdateCategoryRequestSchema = z.object({
    name: z.string().trim().min(1).max(40).optional(),
    sortOrder: z.number().int().optional(),
    colour: CategoryColourSchema.nullable().optional(),
});
export const CategoryListResponseSchema = z.object({
    categories: z.array(CategorySchema),
});
//# sourceMappingURL=categories.js.map